var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basil:instagram-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 10.3438C13.0303 10.3438 12.1003 10.729 11.4146 11.4146C10.729 12.1003 10.3438 13.0303 10.3438 14C10.3438 14.9697 10.729 15.8997 11.4146 16.5854C12.1003 17.271 13.0303 17.6562 14 17.6562C14.9697 17.6562 15.8997 17.271 16.5854 16.5854C17.271 15.8997 17.6562 14.9697 17.6562 14C17.6562 13.0303 17.271 12.1003 16.5854 11.4146C15.8997 10.729 14.9697 10.3438 14 10.3438Z",
    fill: "#FFDCA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11764 3.96767C12.0282 3.53421 15.9746 3.53421 19.8851 3.96767C22.0215 4.20617 23.7439 5.88805 23.9948 8.0323C24.4585 11.9975 24.4585 16.0033 23.9948 19.9685C23.7439 22.1128 22.0215 23.7947 19.8863 24.0343C15.9754 24.4679 12.0285 24.4679 8.11764 24.0343C5.98126 23.7947 4.25889 22.1128 4.00801 19.9697C3.5442 16.0041 3.5442 11.9979 4.00801 8.0323C4.25889 5.88805 5.98126 4.20617 8.11764 3.96767ZM19.6264 7.25042C19.328 7.25042 19.0419 7.36895 18.8309 7.57993C18.6199 7.79091 18.5014 8.07706 18.5014 8.37542C18.5014 8.67379 18.6199 8.95994 18.8309 9.17092C19.0419 9.3819 19.328 9.50042 19.6264 9.50042C19.9248 9.50042 20.2109 9.3819 20.4219 9.17092C20.6329 8.95994 20.7514 8.67379 20.7514 8.37542C20.7514 8.07706 20.6329 7.79091 20.4219 7.57993C20.2109 7.36895 19.9248 7.25042 19.6264 7.25042ZM8.65764 14.0004C8.65764 12.5832 9.22064 11.224 10.2228 10.2218C11.2249 9.21968 12.5841 8.65667 14.0014 8.65667C15.4186 8.65667 16.7778 9.21968 17.78 10.2218C18.7821 11.224 19.3451 12.5832 19.3451 14.0004C19.3451 15.4177 18.7821 16.7769 17.78 17.779C16.7778 18.7812 15.4186 19.3442 14.0014 19.3442C12.5841 19.3442 11.2249 18.7812 10.2228 17.779C9.22064 16.7769 8.65764 15.4177 8.65764 14.0004Z",
    fill: "#FFDCA8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramSvg);
export default __webpack_public_path__ + "static/media/InstagramSVG.cb8660148e6e392d05cefccc0b1f4d4a.svg";
export { ForwardRef as ReactComponent };